import React, { useState } from 'react'
import * as XLSX from 'xlsx';
import '../search-customer/search-customer.scss'
import SinglePage from '../../components/common/page/SinglePage'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import CheckboxInput from '../../components/common/inputs/CheckboxInput'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import InfoBox from '../../components/common/info-box/InfoBox'
import TableFilter from '../../components/common/table-filter/TableFilter';
import Modal from '../../components/common/modal/Modal';
import { BiLoaderAlt } from 'react-icons/bi'
import { customerAxios } from '../../config/axios'
import { toast } from 'react-hot-toast'
import { FcSearch } from "react-icons/fc";
import { FcDeleteDatabase } from "react-icons/fc";
import { FaPlus } from 'react-icons/fa'
import { FiDownload } from "react-icons/fi";
import { productTypes } from '../../assets/javascript/const-data';
import CUProductVariant from '../../components/user/product/CUProductVariant';
import AboutProductVariant from '../../components/user/product/AboutProductVariant';



const ProductVariantList = () => {
    const [form, setForm] = useState({
        key: '',
        product_category: '',
        product_code: '',
        allow_inactive: false
    })
    const [modal, setModal] = useState({ status: false })
    const [loading, setLoading] = useState('')
    const [data, setData] = useState([])
    const [ifSearch, setIfSearch] = useState(false)


    const handleChange = (e) => {

        if (e.target.name === 'allow_inactive') {
            setForm({
                ...form,
                allow_inactive: !form?.allow_inactive
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleApply = (e) => {
        e.preventDefault();

        if (form.key && form.key.length < 3) {
            toast.error('Enter at least 3 characters')
            return;
        }

        if (!form?.key && !form?.product_category && !form?.product_code) {
            toast.error('Select any filter field')
            return;
        }

        setLoading('filter')
        customerAxios.get(`/production-v0/product-variants`, {
            params: {
                search: form.key || '',
                product_category: form?.product_category || '',
                product_code: form?.product_code || '',
                include_inactive: form.allow_inactive === true ? 'true' : '',
                page: 1,
                limit: 1000
            }
        })
            .then((response) => {
                setIfSearch(true)
                setData(response.data?.data || [])
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const openCreateModel = () => {
        setModal({
            status: true, title: "Create Parent Product", width: '600px',
            content: <CUProductVariant setModal={setModal} setData={setData} isEdit={false} />
        })
    }

    // Download Handle
    const downloadFile = (workbook, filename) => {
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        filename = filename + '.xlsx';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE browser
            window.navigator.msSaveOrOpenBlob(data, filename);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    const exportToExcel = (spare) => {

        const workbook = XLSX.utils.book_new();
        // DAR Setup
        const sheetName1 = 'Sheet 1';
        let workSheetData1 = []
        spare.map((data, index) => {
            const obj = {
                'VARIANT CODE': data?.variant_code,
                'VARIANT NAME': data?.variant_name,
                'CATEGORY': data?.product_category,
                'PURCHASE COST': data?.purchase_cost,
                'GP PERCENTAGE': data?.gross_profit?.percentage,
                'GP AMOUNT': data?.gross_profit?.amount,
                'SELLING RATE': data?.selling_rate,
                'STATUS': data?.is_active ? 'ACTIVE' : "INACTIVE",
            }
            workSheetData1.push(obj)
            return obj;
        })

        const worksheet1 = XLSX.utils.json_to_sheet(workSheetData1);
        XLSX.utils.book_append_sheet(workbook, worksheet1, sheetName1);

        return workbook;
    };

    const handleDownload = () => {
        if (data?.[0]) {
            const workbook = exportToExcel(data || [])
            downloadFile(workbook, `Product Variant List By Filter`)
        } else {
            toast.error('Data not available')
        }
    }

    return (
        <div className="search-customer-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Search Product Variants']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <button className='add-button' type='button' onClick={() => openCreateModel()}> <FaPlus /> Product Variant</button>
                        <form action="" onSubmit={handleApply}>
                            <div className="search-section">
                                <h5>Search</h5>
                                <InfoBox description={'Your can search Variant code and Variant Name'} />
                                <NormalInput label='Enter at least 3 characters' name='key' value={form.key} onChangeFun={handleChange} isRequired={false} />
                                <NormalInput label='Product Code' name='product_code' value={form.product_code} onChangeFun={handleChange} isRequired={false} />
                                <SelectInput label={'Product Category'} name={'product_category'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={productTypes?.map((a) => ({ option: a, value: a }))} />
                                <CheckboxInput label={'Include inactive'} name={'allow_inactive'} value={'true'} isRequired={false} onChangeFun={handleChange} />
                            </div>

                            {((form?.key && form?.key?.length > 2) || form?.product_code || form?.product_category) &&
                                <div className="button-div">
                                    <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                                </div>}
                        </form>
                    </div>

                    <div className="result-div">
                        <div className="header-div">
                            {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                                : <h4>Search Product Variants</h4>
                            }
                            <div className="right-div">
                            </div>
                        </div>
                        <div className="items-div">
                            {data?.[0] ?
                                <TableFilter>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Variant Code</th>
                                                <th>Variant Name</th>
                                                <th>Category</th>
                                                <th>Purchase Cost</th>
                                                <th>Gross Profit</th>
                                                <th>Selling Rate</th>
                                                <th>Status</th>
                                                <th>Control</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((product) => {
                                                return <tr key={product.variant_code}>
                                                    <td>{product?.variant_code}</td>
                                                    <td>{product?.variant_name}</td>
                                                    <td>{product?.product_category}</td>
                                                    <td>₹ {product?.purchase_cost || 0}</td>
                                                    <td>₹ {product?.gross_profit?.amount || 0} ({product?.gross_profit?.percentage || 0}%)</td>
                                                    <td>₹ {product?.selling_rate || 0}</td>
                                                    <td style={{ color: product?.is_active ? 'green' : 'red', fontWeight: "600" }} >
                                                        {product?.is_active ? 'Active' : 'In Active'}
                                                    </td>
                                                    <td>
                                                        <div className="button-div">
                                                            <button onClick={() => setModal({
                                                                status: true, title: 'About product', width: '600px',
                                                                content: <AboutProductVariant slug={product?.slug} />
                                                            })}>View</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </TableFilter>
                                : <>
                                    <Spinner height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search products'}
                                        icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                                </>}
                        </div>
                        <p style={{ fontSize: '12px', fontWeight: '500', marginTop: '25px' }}>
                            Gross Profit = Purchase Coset % Gross profit percentage <br></br>
                            BC Amount = Total amount of Bundled components <br></br>
                            Product Amount = Purchase Cost + Gross Profit Amount +  BC Amount <br></br>
                            Selling Rate = Product Amount + Tax amount <br></br>
                        </p>
                        {data?.[0] && <div className="download-button" title='Download XL file' onClick={handleDownload}>
                            <FiDownload />
                        </div>}
                    </div>
                </div>

            </SinglePage>
        </div>
    )
}

export default ProductVariantList